import { type UnknownAction } from '@reduxjs/toolkit';

import { type DataSourceCacheState } from '../../types';

import { dataSourceCacheLoaded } from './actions';

const initialState: DataSourceCacheState = {
  enabled: false,
  dataSourceID: 0,
  dataSourceUID: '',
  ttlQueriesMs: 0,
  ttlResourcesMs: 0,
  defaultTTLMs: 0,
  useDefaultTTL: true,
};

const dataSourceCacheReducer = (state = initialState, action: UnknownAction): DataSourceCacheState => {
  if (dataSourceCacheLoaded.match(action)) {
    return {
      ...action.payload,
    };
  }

  return state;
};

export default {
  dataSourceCache: dataSourceCacheReducer,
};
